/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable, observable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStore } from 'src/luis/types/stores/core/ResourceStore';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

export type LabelsFileNamesStore = ResourceStoreHouse<ResourceStore> & {
    canDisplayLabelFiles: boolean;
    isSearchingLabelsFiles: boolean;
    setCanDisplayLabelFiles: (canDisplayLabelFiles: boolean) => void;
    setIsSearchingLabelsFiles: (isSearchingLabelsFiles: boolean) => void;
};

export const createLabelsFileNamesStore = (): LabelsFileNamesStore => {
    const resourcesStore = createResourceStoreHouse();

    const displayStateStore: SubtractStore<LabelsFileNamesStore, ResourceStoreHouse<ResourceStore>> = {
        canDisplayLabelFiles: true,
        isSearchingLabelsFiles: false,

        /**
         * Sets the canDisplayLabelFiles flag.
         *
         * @param canDisplayLabelFiles The flag to set.
         */
        setCanDisplayLabelFiles(canDisplayLabelFiles) {
            this.canDisplayLabelFiles = canDisplayLabelFiles;
        },

        /**
         * Sets the isSearchingLabelsFiles flag.
         *
         * @param isSearchingLabelsFiles The flag to set.
         */
        setIsSearchingLabelsFiles(isSearchingLabelsFiles) {
            this.isSearchingLabelsFiles = isSearchingLabelsFiles;
        }
    };

    return extendObservable(
        resourcesStore,
        displayStateStore,
        {
            canDisplayLabelFiles: observable,
            setCanDisplayLabelFiles: action,
            isSearchingLabelsFiles: observable,
            setIsSearchingLabelsFiles: action
        },
        { deep: false }
    );
};
